var _a;
import Amount from "./Amount";
class Books {
    size;
    constructor(response) {
        this.size = response.size !== undefined ? new Amount(response.size) : undefined;
    }
    #clone() {
        return new _a({
            size: this.size
        });
    }
    updateValue(value) {
        const clone = this.#clone();
        if (clone.size === undefined) {
            clone.size = new Amount({});
        }
        clone.size.value = value;
        return clone;
    }
}
_a = Books;
export default Books;
